import {
  ChangeDetectionStrategy,
  Component,
  input,
  effect,
  signal,
  inject,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FilesService } from '../../shared/services/files-service/files.service';
import { filesDownloadErrorConfig } from './settings/files-download.settings';
import { catchError, throwError } from 'rxjs';

@Component({
  selector: 'ri-resolution-ui-files-download',
  imports: [MatIconModule],
  templateUrl: './files-download.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilesDownloadComponent {
  private readonly filesService = inject(FilesService);

  public readonly resolverFileId = input.required<string>();

  private readonly _hasError = signal<boolean>(false);
  readonly hasError = this._hasError.asReadonly();

  private readonly _errorMessage = signal<string>('');
  readonly errorMessage = this._errorMessage.asReadonly();
  private readonly _iconClass = signal<string>('');
  readonly iconClass = this._iconClass.asReadonly();

  constructor() {
    effect(() => {
      this.filesService
        .previewFileById(this.resolverFileId())
        .pipe(
          catchError((error) => {
            let errorConfig = filesDownloadErrorConfig.unexpectedError;
            if (error.status === 401 || error.status === 403) {
              errorConfig = filesDownloadErrorConfig.permissionsError;
            } else if (error.status === 404) {
              errorConfig = filesDownloadErrorConfig.fileNotFoundError;
            }

            this._errorMessage.set(errorConfig.message);
            this._iconClass.set(errorConfig.iconClass);
            this._hasError.set(true);

            return throwError(() => {
              return error;
            });
          })
        )
        .subscribe(() => {});
    });
  }
}
